module.exports = __webpack_public_path__ + "static/media/ic-floating-button.43f05967.svg";